// SkyTracker @skytracker/web — read/write filter state into URL query params.
import type { ClientFilters } from '@skytracker/shared';

const KEYS = {
  cats: 'c',
  altMin: 'amin',
  altMax: 'amax',
  spdMin: 'smin',
  spdMax: 'smax',
  emergency: 'eo',
  ground: 'g',
};

export function filtersToUrl(filters: ClientFilters): string {
  const p = new URLSearchParams();
  if (filters.categories?.length) p.set(KEYS.cats, filters.categories.join(','));
  if (filters.altitude_ft) {
    p.set(KEYS.altMin, String(filters.altitude_ft[0]));
    p.set(KEYS.altMax, String(filters.altitude_ft[1]));
  }
  if (filters.speed_kt) {
    p.set(KEYS.spdMin, String(filters.speed_kt[0]));
    p.set(KEYS.spdMax, String(filters.speed_kt[1]));
  }
  if (filters.emergency_only) p.set(KEYS.emergency, '1');
  if (filters.on_ground && filters.on_ground !== 'all') p.set(KEYS.ground, filters.on_ground);
  return p.toString();
}

export function filtersFromUrl(): ClientFilters {
  const p = new URLSearchParams(window.location.search);
  const filters: ClientFilters = {};
  const cats = p.get(KEYS.cats);
  if (cats) filters.categories = cats.split(',') as ClientFilters['categories'];
  const aMin = p.get(KEYS.altMin);
  const aMax = p.get(KEYS.altMax);
  if (aMin && aMax) filters.altitude_ft = [Number(aMin), Number(aMax)];
  const sMin = p.get(KEYS.spdMin);
  const sMax = p.get(KEYS.spdMax);
  if (sMin && sMax) filters.speed_kt = [Number(sMin), Number(sMax)];
  if (p.get(KEYS.emergency) === '1') filters.emergency_only = true;
  const ground = p.get(KEYS.ground) as ClientFilters['on_ground'];
  if (ground) filters.on_ground = ground;
  return filters;
}

export function syncFiltersToUrl(filters: ClientFilters): void {
  const qs = filtersToUrl(filters);
  const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;
  window.history.replaceState(null, '', url);
}
